"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthoringSignatureClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const sdk_constants_1 = require("../../constants/sdk.constants");
class AuthoringSignatureClient {
    static newInstance(options, retryOptions) {
        return new AuthoringSignatureClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions));
    }
    constructor(client) {
        this.client = client;
    }
    async signEditAssessmentTemplateRequest(assessmentTemplateId, config, headers) {
        const response = await this.client.post(`${sdk_constants_1.AUTHORING_API_PREFIX}/signature.editAssessmentTemplate`, { assessmentTemplateId, config }, { headers });
        return response.body.data;
    }
    async signViewAssessmentTemplateRequest(assessmentTemplateId, inline = false, items = [], config, headers) {
        const response = await this.client.post(`${sdk_constants_1.AUTHORING_API_PREFIX}/signature.viewAssessmentTemplate`, { assessmentTemplateId, inline, items, config }, { headers });
        return response.body.data;
    }
    async signPreviewItemsRequest(externalItemId, headers) {
        const response = await this.client.post(`${sdk_constants_1.AUTHORING_API_PREFIX}/signature.previewItem`, { externalItemId }, { headers });
        return response.body.data;
    }
    async showContentEditorTest(config, headers) {
        const response = await this.client.post(`${sdk_constants_1.AUTHORING_API_PREFIX}/signature.showContentEditorTest`, { config }, { headers });
        return response.body.data;
    }
}
exports.AuthoringSignatureClient = AuthoringSignatureClient;
//# sourceMappingURL=authoring-signature.client.js.map